import { Step } from 'react-joyride';

export const sidebarTourSteps: Step[] = [
  {
    target: '[data-tour="sidebar"]',
    content: (
      <div>
        <h4>Navigation Sidebar</h4>
        <p>
          Your main navigation hub. All key features and sections are accessible from here. Let's
          explore what each section offers.
        </p>
      </div>
    ),
    placement: 'right',
    disableBeacon: true
  },
  {
    target: '[data-tour="sidebar-dashboard"]',
    content: (
      <div>
        <h4>Dashboard</h4>
        <p>Return to your main dashboard with real-time metrics and overview at any time.</p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="sidebar-conversations"]',
    content: (
      <div>
        <h4>Conversations</h4>
        <p>
          Access all your customer conversations here. Connect with customers in real-time and
          manage chat sessions.
        </p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="sidebar-call-requests"]',
    content: (
      <div>
        <h4>Call Requests</h4>
        <p>Manage incoming call requests from customers who want to speak with an agent.</p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="sidebar-documents"]',
    content: (
      <div>
        <h4>Documents</h4>
        <p>
          Handle document-related tasks including e-signatures, forms, and document verification.
        </p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="sidebar-records"]',
    content: (
      <div>
        <h4>Interactions</h4>
        <p>View historical chat records and conversation history for all your customers.</p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="sidebar-reports"]',
    content: (
      <div>
        <h4>Reports</h4>
        <p>
          Access analytics, scheduled reports, and activity logs. Gain insights into your team's
          performance.
        </p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="sidebar-agents"]',
    content: (
      <div>
        <h4>Agents</h4>
        <p>Manage your team members, assign roles, and configure agent settings.</p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="sidebar-teams"]',
    content: (
      <div>
        <h4>Teams</h4>
        <p>Organize agents into teams for better workflow management and collaboration.</p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="sidebar-settings"]',
    content: (
      <div>
        <h4>Settings</h4>
        <p>
          Configure your dashboard, customize widgets, set up integrations, and manage security
          settings.
        </p>
      </div>
    ),
    placement: 'right'
  }
];
